// 优化后的 API 调用示例
// src/api/system.js
import axios from 'axios'

// 获取系统配置
export function getSystemConfig() {
  return axios({
    url: '/api/system/config',
    method: 'get'
  })
}

// 更新系统配置
export function updateSystemConfig(data) {
  return axios({
    url: '/api/system/config',
    method: 'put',
    data
  })
}